module.exports = __webpack_public_path__ + "img/samplering.870558a.webp";